import {
  IonButton,
  IonCol,
  IonGrid,
  IonInput,
  IonItem,
  IonLabel,
  IonRow,
} from '@ionic/react';
import React from 'react';
import { SubCategory } from '../../../../interfaces/Meta';
import useStyles from '../../styles';

interface ListingAssociatedSubcategoryRowProps {
  subcategory: SubCategory;
  removeSubcategory: (id: number) => void;
  viewServices: (id: number) => void;
}

// eslint-disable-next-line max-len
const ListingAssociatedSubcategoryRow: React.FunctionComponent<ListingAssociatedSubcategoryRowProps> = ({
  subcategory,
  removeSubcategory,
  viewServices,
}: ListingAssociatedSubcategoryRowProps) => {
  const classes = useStyles();
  const {
    id, name, translation, num_services,
  } = subcategory;

  return (
    <>
      <div className={classes.crisisCategoryCardHeader} />
      <div className={classes.providerCardContent}>
        <IonGrid>
          <IonRow>
            <IonCol sizeXs="12" sizeSm="12" sizeMd="12" sizeLg="8">
              <div className={classes.providerNameRow}>
                <IonItem
                  className={[
                    classes.providerOrgName,
                    'disabled-pointer-events',
                  ].join(' ')}
                >
                  <IonLabel className={classes.rowLabel} position="floating" color="primary">
                    Associated Subcategory Name
                  </IonLabel>
                  <IonInput
                    color="primary"
                    value={`${name} ${translation?.es?.name ? '/' : ''} ${translation?.es?.name ?? ''}`}
                  />
                </IonItem>
              </div>
            </IonCol>
            <IonCol sizeXs="12" sizeSm="12" sizeMd="12" sizeLg="1" />
            <IonCol sizeXs="12" sizeSm="12" sizeMd="12" sizeLg="3">
              <IonButton
                className={classes.providerActionButton}
                shape="round"
                fill="solid"
                color="primary"
                onClick={(): void => viewServices(id)}
              >
                VIEW SERVICES ({num_services})
              </IonButton>
              <IonButton
                className={classes.removeButton}
                shape="round"
                fill="outline"
                onClick={(): void => removeSubcategory(id)}
              >
                Remove
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </div>
    </>
  );
};

export default ListingAssociatedSubcategoryRow;
